// Fatia S1: código de 6 dígitos do aplicativo autenticador (2º fator do login).
import { useState, type FormEvent } from 'react'
import { Link, Navigate, useNavigate, useSearchParams } from 'react-router-dom'
import { ShieldCheck } from 'lucide-react'
import { api, errorMessage } from '../../lib/api'
import { useSession } from '../../lib/session'
import AuthShell, { FormError } from '../../features/auth/AuthShell'
import { safeNext } from '../../features/auth/session-helpers'
import { Loading } from '../../ui'

export default function TwoFactor() {
  const [params] = useSearchParams()
  const next = safeNext(params.get('next'))
  const navigate = useNavigate()
  const { me, loading, refresh } = useSession()
  const [code, setCode] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  if (loading) return <AuthShell title="Verificação em duas etapas"><Loading lines={2} /></AuthShell>
  if (!me) return <Navigate to={`/login?next=${encodeURIComponent(next)}`} replace />
  if (!me.pending2fa) return <Navigate to={next} replace />

  async function submit(e: FormEvent) {
    e.preventDefault()
    setError(null)
    setBusy(true)
    try {
      await api.post('/auth/2fa/verify', { code })
      await refresh()
      navigate(next, { replace: true })
    } catch (err) {
      setError(errorMessage(err))
      setCode('')
    } finally {
      setBusy(false)
    }
  }

  return (
    <AuthShell title="Verificação em duas etapas" sub="Abra o aplicativo autenticador do seu celular e digite o código de 6 números do Seu Impulso." footer={<Link to="/sair">Entrar com outra conta</Link>}>
      <form className="stack" style={{ gap: 14 }} onSubmit={submit}>
        <FormError error={error} />
        <div className="field">
          <label htmlFor="code" className="row" style={{ gap: 6 }}><ShieldCheck size={15} /> Código</label>
          <input
            id="code"
            className="input"
            inputMode="numeric"
            autoComplete="one-time-code"
            pattern="[0-9]{6}"
            maxLength={6}
            autoFocus
            value={code}
            onChange={(e) => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
            style={{ fontSize: 24, letterSpacing: '0.4em', textAlign: 'center' }}
            required
          />
        </div>
        <button className="btn primary lg block" disabled={busy || code.length !== 6}>{busy ? 'Conferindo…' : 'Confirmar'}</button>
        <p className="small muted">Perdeu o acesso ao aplicativo? Fale com o suporte pelo e-mail informado na política de privacidade.</p>
      </form>
    </AuthShell>
  )
}
